// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsPageTabsComponent } from '../Components/tools-page-tabs/tools-page-tabs.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ToolsPageTabsComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ToolsPageTabsComponent
  ]
})

export class ToolsPageTabsModule { }
